import React from "react";
import MakeIssuer from "../components/MakeIssuer";
import RevokeIssuer from "./RevokeIssuer";

const CreateRevokeIssuer = () => {
  return (
    <>
      <MakeIssuer />
      <RevokeIssuer />
    </>
  );
};

export default CreateRevokeIssuer;
